(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["arkidecor-finishes"] && !Shopify.designMode) return;
  try {
    
  if (!customElements.get('arkidecor-finishes')) {
    customElements.define('arkidecor-finishes', class extends HTMLElement {
      connectedCallback() {
        if (this.bound) return;
        this.bound = true;
        this.dialog = this.querySelector('dialog');
        if (!this.dialog || typeof this.dialog.showModal !== 'function') return;
        this.addEventListener('click', (event) => {
          const trigger = event.target.closest('[data-finish-preview]');
          if (trigger && this.contains(trigger)) {
            event.preventDefault();
            this.opener = trigger;
            const title = trigger.dataset.finishName;
            const image = this.querySelector('.adf__dialog-image');
            image.src = trigger.querySelector('img').currentSrc;
            const fullImage = new Image();
            const requestedUrl = trigger.href;
            this.previewUrl = requestedUrl;
            fullImage.onload = () => {
              if (this.previewUrl === requestedUrl) image.src = requestedUrl;
            };
            fullImage.src = requestedUrl;
            image.alt = trigger.querySelector('img').alt;
            this.querySelector('[data-dialog-title]').textContent = title;
            this.querySelector('[data-dialog-group]').textContent = trigger.dataset.finishGroup;
            const cta = this.querySelector('[data-dialog-cta]');
            if (cta) {
              const url = new URL(this.querySelector('.adf__footer .adf__cta').href);
              url.searchParams.set('product', this.dataset.productLabel + ' — ' + title);
              url.searchParams.set('finish', title);
              cta.href = url.href;
            }
            this.dialog.showModal();
          }
          if (event.target.closest('.adf__close')) this.dialog.close();
        });
        this.dialog.addEventListener('click', (event) => {
          if (event.target !== this.dialog) return;
          const rect = this.dialog.getBoundingClientRect();
          if (event.clientX < rect.left || event.clientX > rect.right || event.clientY < rect.top || event.clientY > rect.bottom) this.dialog.close();
        });
        this.dialog.addEventListener('close', () => {
          if (this.opener?.isConnected) this.opener.focus({ preventScroll: true });
        });
      }
      disconnectedCallback() {
        if (this.dialog?.open) this.dialog.close();
      }
    });
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["header"]) return;
  try {
    
  class StickyHeader extends HTMLElement {
    constructor() {
      super();
      this.setHeaderHeight = this.setHeaderHeight.bind(this);
    }

    connectedCallback() {
      this.header = document.querySelector('.section-header');
      this.mobileMediaQuery = window.matchMedia('(max-width: 990px)');
      this.headerIsAlwaysSticky =
        this.getAttribute('data-sticky-type') === 'always' ||
        this.getAttribute('data-sticky-type') === 'reduce-logo-size';
      this.headerBounds = {};

      this.setHeaderHeight();

      this.mobileMediaQuery.addEventListener('change', this.setHeaderHeight);

      if (this.headerIsAlwaysSticky) {
        this.header.classList.add('shopify-section-header-sticky');
      }

      this.currentScrollTop = 0;
      this.preventReveal = false;
      this.predictiveSearches = this.querySelectorAll('predictive-search');

      this.onScrollHandler = this.onScroll.bind(this);
      this.hideHeaderOnScrollUp = () => (this.preventReveal = true);

      this.addEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.addEventListener('scroll', this.onScrollHandler, false);

      this.createObserver();
    }

    setHeaderHeight() {
      document.documentElement.style.setProperty('--header-height', `${this.header.offsetHeight}px`);
    }

    disconnectedCallback() {
      this.mobileMediaQuery.removeEventListener('change', this.setHeaderHeight);
      this.removeEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.removeEventListener('scroll', this.onScrollHandler);
    }

    createObserver() {
      let observer = new IntersectionObserver((entries, observer) => {
        this.headerBounds = entries[0].intersectionRect;
        observer.disconnect();
      });

      observer.observe(this.header);
    }

    onScroll() {
      const scrollTop = window.pageYOffset || document.documentElement.scrollTop;

      if ([...this.predictiveSearches].some((predictiveSearch) => predictiveSearch.isOpen)) return;

      if (scrollTop > this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        this.header.classList.add('scrolled-past-header');
        if (this.preventHide) return;
        requestAnimationFrame(this.hide.bind(this));
      } else if (scrollTop < this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        this.header.classList.add('scrolled-past-header');
        if (!this.preventReveal) {
          requestAnimationFrame(this.reveal.bind(this));
        } else {
          window.clearTimeout(this.isScrolling);

          this.isScrolling = setTimeout(() => {
            this.preventReveal = false;
          }, 66);

          requestAnimationFrame(this.hide.bind(this));
        }
      } else if (scrollTop <= this.headerBounds.top) {
        this.header.classList.remove('scrolled-past-header');
        requestAnimationFrame(this.reset.bind(this));
      }

      this.currentScrollTop = scrollTop;
    }

    hide() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.add('shopify-section-header-hidden', 'shopify-section-header-sticky');
      this.closeMenuDisclosure();
      this.closeSearchModal();
    }

    reveal() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.add('shopify-section-header-sticky', 'animate');
      this.header.classList.remove('shopify-section-header-hidden');
    }

    reset() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.remove('shopify-section-header-hidden', 'shopify-section-header-sticky', 'animate');
    }

    closeMenuDisclosure() {
      this.disclosures = this.disclosures || this.header.querySelectorAll('header-menu');
      this.disclosures.forEach((disclosure) => disclosure.close());
    }

    closeSearchModal() {
      this.searchModals = this.searchModals || this.header.querySelectorAll('details-modal');
      this.searchModals.forEach((searchModal) => searchModal.close(false));
    }
  }

  // The account `open` event is composed but does not bubble, so listen during capture.
  // Anchor the dialog to the bottom of the account button itself. The header group can be
  // much taller than the button's row (for example, a top-left logo pushes the menu to a
  // second row), so anchoring to the section bottom drops the dialog too low.
  document.addEventListener(
    'open',
    (event) => {
      if (!(event.target instanceof HTMLElement) || !event.target.matches('shopify-account')) return;

      const bottom = Math.max(0, Math.round(event.target.getBoundingClientRect().bottom));
      event.target.style.setProperty('--account-dialog-top', `${bottom}px`);
    },
    true
  );

  customElements.define('sticky-header', StickyHeader);

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["product-faqs"] && !Shopify.designMode) return;
  try {
    
  class ProductFaqs extends HTMLElement {
    connectedCallback() {
      this.buttons = Array.from(this.querySelectorAll('.product-faqs__topic[data-faq-topic]'));
      this.items = Array.from(this.querySelectorAll('[data-faq-item]'));
      const availableTopics = new Set(this.items.map((item) => item.dataset.faqTopic));
      this.buttons.forEach((button) => {
        if (button.dataset.faqTopic !== 'all' && !availableTopics.has(button.dataset.faqTopic)) {
          button.remove();
        }
      });
      this.buttons = Array.from(this.querySelectorAll('.product-faqs__topic[data-faq-topic]'));
      this.buttons.forEach((button) => {
        button.addEventListener('click', () => this.selectTopic(button.dataset.faqTopic));
      });
    }

    selectTopic(topic) {
      const hasMatches = topic === 'all' || this.items.some((item) => item.dataset.faqTopic === topic);
      const selectedTopic = hasMatches ? topic : 'all';
      this.buttons.forEach((button) => {
        const active = button.dataset.faqTopic === selectedTopic;
        button.classList.toggle('is-active', active);
        button.setAttribute('aria-pressed', active ? 'true' : 'false');
      });
      this.items.forEach((item) => {
        const shouldHide = selectedTopic !== 'all' && item.dataset.faqTopic !== selectedTopic;
        item.hidden = shouldHide;
        if (shouldHide) item.open = false;
      });
    }
  }

  if (!customElements.get('product-faqs')) {
    customElements.define('product-faqs', ProductFaqs);
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["technical-resources"] && !Shopify.designMode) return;
  try {
    
  const initializeTechnicalResources = (scope = document) => {
    scope.querySelectorAll('[data-technical-resources]').forEach((section) => {
      if (section.dataset.initialized === 'true') return;
      section.dataset.initialized = 'true';

      const search = section.querySelector('[data-resource-search]');
      const product = section.querySelector('[data-resource-product]');
      const type = section.querySelector('[data-resource-type]');
      const clear = section.querySelector('[data-resource-clear]');
      const urlParams = new URLSearchParams(window.location.search);
      const technicalResourceParamsApplied = true;
      const initialSearch = urlParams.get('q') || '';
      const initialProduct = urlParams.get('product') || '';
      const initialType = urlParams.get('type') || '';

      if (initialSearch) search.value = initialSearch;
      if (initialProduct && Array.from(product.options).some((option) => option.value === initialProduct)) {
        product.value = initialProduct;
      }
      if (initialType && Array.from(type.options).some((option) => option.value === initialType)) {
        type.value = initialType;
      }
      const cards = Array.from(section.querySelectorAll('[data-resource-card]'));
      const count = section.querySelector('[data-resource-count]');
      const empty = section.querySelector('[data-resource-empty]');

      const update = () => {
        const query = search.value.trim().toLowerCase();
        const productValue = product.value;
        const typeValue = type.value;
        let visible = 0;

        cards.forEach((card) => {
          const matchesSearch = query === '' || card.dataset.search.includes(query);
          const matchesProduct = productValue === '' || card.dataset.product === productValue;
          const matchesType = typeValue === '' || card.dataset.type === typeValue;
          const matches = matchesSearch && matchesProduct && matchesType;
          card.hidden = !matches;
          if (matches) visible += 1;
        });

        const label = visible === 1 ? section.dataset.resultSingular : section.dataset.resultPlural;
        count.textContent = `${visible} ${label}`;
        empty.hidden = visible !== 0;
      };

      const updateUrl = () => {
        const params = new URLSearchParams(window.location.search);
        const query = search.value.trim();
        query ? params.set('q', query) : params.delete('q');
        product.value ? params.set('product', product.value) : params.delete('product');
        type.value ? params.set('type', type.value) : params.delete('type');
        const next = `${window.location.pathname}${params.toString() ? `?${params.toString()}` : ''}${window.location.hash}`;
        window.history.replaceState({}, '', next);
      };

      search.addEventListener('input', () => {
        update();
        updateUrl();
      });
      product.addEventListener('change', () => {
        update();
        updateUrl();
      });
      type.addEventListener('change', () => {
        update();
        updateUrl();
      });
      clear.addEventListener('click', () => {
        search.value = '';
        product.value = '';
        type.value = '';
        update();
        updateUrl();
        search.focus();
      });

      update();
    });
  };

  initializeTechnicalResources();
  document.addEventListener('shopify:section:load', (event) => initializeTechnicalResources(event.target));

  } catch(e) { console.error(e); }
})();
})();
